import * as React from 'react';
import { Tabs } from '@ui';
import { t } from '@lib/i18n';
import { InstallTokenManagement } from './InstallTokenManagement';
import { FortressKeyManagement } from './FortressKeyManagement';

/**
 * 密钥管理容器
 *
 * 导航栏「密钥管理」入口，内含两个页卡：
 *   - 安装令牌（InstallTokenManagement，原 install-tokens 界面）
 *   - 堡垒密钥（FortressKeyManagement，Proxy Auth Key）
 *
 * 注意：原 V2 的 Agent 密钥界面已隐藏（代码见 git 历史，
 * commit 007d5d0 之前的 features-v2/agent-key，如需恢复可回退）。
 */

export const KeyManagement: React.FC = () => {
  const items = [
    {
      key: 'install-token',
      label: t('dashboard.installTokens'),
      children: <InstallTokenManagement />,
    },
    {
      key: 'fortress-key',
      label: t('keyManagement.fortressKey'),
      children: <FortressKeyManagement />,
    },
  ];

  return (
    <div className="space-y-4">
      <Tabs items={items} />
    </div>
  );
};
